/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as authAuthRouteImport } from './routes/(auth)/_auth'
import { Route as appAppRouteImport } from './routes/(app)/_app'
import { Route as appAppIndexRouteImport } from './routes/(app)/_app.index'
import { Route as authAuthLoginRouteImport } from './routes/(auth)/_auth.login'
import { Route as appAppUserProfilRouteImport } from './routes/(app)/_app.user-profil'
import { Route as appAppUpcomingEventsRouteImport } from './routes/(app)/_app.upcoming-events'
import { Route as appAppRoadShowRouteImport } from './routes/(app)/_app.roadShow'
import { Route as appAppOfflineVideosRouteImport } from './routes/(app)/_app.offline-videos'
import { Route as appAppOfflineModeRouteImport } from './routes/(app)/_app.offline-mode'
import { Route as appAppNotificationsRouteImport } from './routes/(app)/_app.notifications'
import { Route as appAppMyAcademyRouteImport } from './routes/(app)/_app.my-academy'
import { Route as appAppCoursesRouteImport } from './routes/(app)/_app.courses'
import { Route as appAppContactRouteImport } from './routes/(app)/_app.contact'
import { Route as appAppArticlesBriefRouteImport } from './routes/(app)/_app.articles-brief'
import { Route as appAppArticlesRouteImport } from './routes/(app)/_app.articles'
import { Route as appAppArticlesIndexRouteImport } from './routes/(app)/_app.articles.index'
import { Route as appAppWorkshopsTypeRouteImport } from './routes/(app)/_app.workshops.$type'
import { Route as appAppStudyStudyIdRouteImport } from './routes/(app)/_app.study.$studyId'
import { Route as appAppCoursesPopRouteImport } from './routes/(app)/_app.courses_.pop'
import { Route as appAppCoursesKursRachunkowoscRouteImport } from './routes/(app)/_app.courses_.kurs-rachunkowosc'
import { Route as appAppCoursesKursDoradcaPodatkowyRouteImport } from './routes/(app)/_app.courses_.kurs-doradca-podatkowy'
import { Route as appAppCourseCourseKeyRouteImport } from './routes/(app)/_app.course.$courseKey'
import { Route as appAppArticlesArticleIdRouteImport } from './routes/(app)/_app.articles_.$articleId'
import { Route as appAppWorkshopsTypeWorkshopIdRouteImport } from './routes/(app)/_app.workshops_.$type.$workshopId'
import { Route as appAppWorkshopsTypeSlugIdAuthRouteImport } from './routes/(app)/_app.workshops_.$type.$slugId.auth'

const authAuthRoute = authAuthRouteImport.update({
  id: '/(auth)/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const appAppRoute = appAppRouteImport.update({
  id: '/(app)/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const appAppIndexRoute = appAppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appAppRoute,
} as any)
const authAuthLoginRoute = authAuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => authAuthRoute,
} as any)
const appAppUserProfilRoute = appAppUserProfilRouteImport.update({
  id: '/user-profil',
  path: '/user-profil',
  getParentRoute: () => appAppRoute,
} as any)
const appAppUpcomingEventsRoute = appAppUpcomingEventsRouteImport.update({
  id: '/upcoming-events',
  path: '/upcoming-events',
  getParentRoute: () => appAppRoute,
} as any)
const appAppRoadShowRoute = appAppRoadShowRouteImport.update({
  id: '/roadShow',
  path: '/roadShow',
  getParentRoute: () => appAppRoute,
} as any)
const appAppOfflineVideosRoute = appAppOfflineVideosRouteImport.update({
  id: '/offline-videos',
  path: '/offline-videos',
  getParentRoute: () => appAppRoute,
} as any)
const appAppOfflineModeRoute = appAppOfflineModeRouteImport.update({
  id: '/offline-mode',
  path: '/offline-mode',
  getParentRoute: () => appAppRoute,
} as any)
const appAppNotificationsRoute = appAppNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => appAppRoute,
} as any)
const appAppMyAcademyRoute = appAppMyAcademyRouteImport.update({
  id: '/my-academy',
  path: '/my-academy',
  getParentRoute: () => appAppRoute,
} as any)
const appAppCoursesRoute = appAppCoursesRouteImport.update({
  id: '/courses',
  path: '/courses',
  getParentRoute: () => appAppRoute,
} as any)
const appAppContactRoute = appAppContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => appAppRoute,
} as any)
const appAppArticlesBriefRoute = appAppArticlesBriefRouteImport.update({
  id: '/articles-brief',
  path: '/articles-brief',
  getParentRoute: () => appAppRoute,
} as any)
const appAppArticlesRoute = appAppArticlesRouteImport.update({
  id: '/articles',
  path: '/articles',
  getParentRoute: () => appAppRoute,
} as any)
const appAppArticlesIndexRoute = appAppArticlesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appAppArticlesRoute,
} as any)
const appAppWorkshopsTypeRoute = appAppWorkshopsTypeRouteImport.update({
  id: '/workshops/$type',
  path: '/workshops/$type',
  getParentRoute: () => appAppRoute,
} as any)
const appAppStudyStudyIdRoute = appAppStudyStudyIdRouteImport.update({
  id: '/study/$studyId',
  path: '/study/$studyId',
  getParentRoute: () => appAppRoute,
} as any)
const appAppCoursesPopRoute = appAppCoursesPopRouteImport.update({
  id: '/courses_/pop',
  path: '/courses/pop',
  getParentRoute: () => appAppRoute,
} as any)
const appAppCoursesKursRachunkowoscRoute =
  appAppCoursesKursRachunkowoscRouteImport.update({
    id: '/courses_/kurs-rachunkowosc',
    path: '/courses/kurs-rachunkowosc',
    getParentRoute: () => appAppRoute,
  } as any)
const appAppCoursesKursDoradcaPodatkowyRoute =
  appAppCoursesKursDoradcaPodatkowyRouteImport.update({
    id: '/courses_/kurs-doradca-podatkowy',
    path: '/courses/kurs-doradca-podatkowy',
    getParentRoute: () => appAppRoute,
  } as any)
const appAppCourseCourseKeyRoute = appAppCourseCourseKeyRouteImport.update({
  id: '/course/$courseKey',
  path: '/course/$courseKey',
  getParentRoute: () => appAppRoute,
} as any)
const appAppArticlesArticleIdRoute = appAppArticlesArticleIdRouteImport.update({
  id: '/articles_/$articleId',
  path: '/articles/$articleId',
  getParentRoute: () => appAppRoute,
} as any)
const appAppWorkshopsTypeWorkshopIdRoute =
  appAppWorkshopsTypeWorkshopIdRouteImport.update({
    id: '/workshops_/$type/$workshopId',
    path: '/workshops/$type/$workshopId',
    getParentRoute: () => appAppRoute,
  } as any)
const appAppWorkshopsTypeSlugIdAuthRoute =
  appAppWorkshopsTypeSlugIdAuthRouteImport.update({
    id: '/workshops_/$type/$slugId/auth',
    path: '/workshops/$type/$slugId/auth',
    getParentRoute: () => appAppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/articles': typeof appAppArticlesRouteWithChildren
  '/articles-brief': typeof appAppArticlesBriefRoute
  '/contact': typeof appAppContactRoute
  '/courses': typeof appAppCoursesRoute
  '/my-academy': typeof appAppMyAcademyRoute
  '/notifications': typeof appAppNotificationsRoute
  '/offline-mode': typeof appAppOfflineModeRoute
  '/offline-videos': typeof appAppOfflineVideosRoute
  '/roadShow': typeof appAppRoadShowRoute
  '/upcoming-events': typeof appAppUpcomingEventsRoute
  '/user-profil': typeof appAppUserProfilRoute
  '/login': typeof authAuthLoginRoute
  '/': typeof appAppIndexRoute
  '/articles/$articleId': typeof appAppArticlesArticleIdRoute
  '/course/$courseKey': typeof appAppCourseCourseKeyRoute
  '/courses/kurs-doradca-podatkowy': typeof appAppCoursesKursDoradcaPodatkowyRoute
  '/courses/kurs-rachunkowosc': typeof appAppCoursesKursRachunkowoscRoute
  '/courses/pop': typeof appAppCoursesPopRoute
  '/study/$studyId': typeof appAppStudyStudyIdRoute
  '/workshops/$type': typeof appAppWorkshopsTypeRoute
  '/articles/': typeof appAppArticlesIndexRoute
  '/workshops/$type/$workshopId': typeof appAppWorkshopsTypeWorkshopIdRoute
  '/workshops/$type/$slugId/auth': typeof appAppWorkshopsTypeSlugIdAuthRoute
}
export interface FileRoutesByTo {
  '/articles-brief': typeof appAppArticlesBriefRoute
  '/contact': typeof appAppContactRoute
  '/courses': typeof appAppCoursesRoute
  '/my-academy': typeof appAppMyAcademyRoute
  '/notifications': typeof appAppNotificationsRoute
  '/offline-mode': typeof appAppOfflineModeRoute
  '/offline-videos': typeof appAppOfflineVideosRoute
  '/roadShow': typeof appAppRoadShowRoute
  '/upcoming-events': typeof appAppUpcomingEventsRoute
  '/user-profil': typeof appAppUserProfilRoute
  '/login': typeof authAuthLoginRoute
  '/': typeof appAppIndexRoute
  '/articles/$articleId': typeof appAppArticlesArticleIdRoute
  '/course/$courseKey': typeof appAppCourseCourseKeyRoute
  '/courses/kurs-doradca-podatkowy': typeof appAppCoursesKursDoradcaPodatkowyRoute
  '/courses/kurs-rachunkowosc': typeof appAppCoursesKursRachunkowoscRoute
  '/courses/pop': typeof appAppCoursesPopRoute
  '/study/$studyId': typeof appAppStudyStudyIdRoute
  '/workshops/$type': typeof appAppWorkshopsTypeRoute
  '/articles': typeof appAppArticlesIndexRoute
  '/workshops/$type/$workshopId': typeof appAppWorkshopsTypeWorkshopIdRoute
  '/workshops/$type/$slugId/auth': typeof appAppWorkshopsTypeSlugIdAuthRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/(app)/_app': typeof appAppRouteWithChildren
  '/(auth)/_auth': typeof authAuthRouteWithChildren
  '/(app)/_app/articles': typeof appAppArticlesRouteWithChildren
  '/(app)/_app/articles-brief': typeof appAppArticlesBriefRoute
  '/(app)/_app/contact': typeof appAppContactRoute
  '/(app)/_app/courses': typeof appAppCoursesRoute
  '/(app)/_app/my-academy': typeof appAppMyAcademyRoute
  '/(app)/_app/notifications': typeof appAppNotificationsRoute
  '/(app)/_app/offline-mode': typeof appAppOfflineModeRoute
  '/(app)/_app/offline-videos': typeof appAppOfflineVideosRoute
  '/(app)/_app/roadShow': typeof appAppRoadShowRoute
  '/(app)/_app/upcoming-events': typeof appAppUpcomingEventsRoute
  '/(app)/_app/user-profil': typeof appAppUserProfilRoute
  '/(auth)/_auth/login': typeof authAuthLoginRoute
  '/(app)/_app/': typeof appAppIndexRoute
  '/(app)/_app/articles_/$articleId': typeof appAppArticlesArticleIdRoute
  '/(app)/_app/course/$courseKey': typeof appAppCourseCourseKeyRoute
  '/(app)/_app/courses_/kurs-doradca-podatkowy': typeof appAppCoursesKursDoradcaPodatkowyRoute
  '/(app)/_app/courses_/kurs-rachunkowosc': typeof appAppCoursesKursRachunkowoscRoute
  '/(app)/_app/courses_/pop': typeof appAppCoursesPopRoute
  '/(app)/_app/study/$studyId': typeof appAppStudyStudyIdRoute
  '/(app)/_app/workshops/$type': typeof appAppWorkshopsTypeRoute
  '/(app)/_app/articles/': typeof appAppArticlesIndexRoute
  '/(app)/_app/workshops_/$type/$workshopId': typeof appAppWorkshopsTypeWorkshopIdRoute
  '/(app)/_app/workshops_/$type/$slugId/auth': typeof appAppWorkshopsTypeSlugIdAuthRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/articles'
    | '/articles-brief'
    | '/contact'
    | '/courses'
    | '/my-academy'
    | '/notifications'
    | '/offline-mode'
    | '/offline-videos'
    | '/roadShow'
    | '/upcoming-events'
    | '/user-profil'
    | '/login'
    | '/'
    | '/articles/$articleId'
    | '/course/$courseKey'
    | '/courses/kurs-doradca-podatkowy'
    | '/courses/kurs-rachunkowosc'
    | '/courses/pop'
    | '/study/$studyId'
    | '/workshops/$type'
    | '/articles/'
    | '/workshops/$type/$workshopId'
    | '/workshops/$type/$slugId/auth'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/articles-brief'
    | '/contact'
    | '/courses'
    | '/my-academy'
    | '/notifications'
    | '/offline-mode'
    | '/offline-videos'
    | '/roadShow'
    | '/upcoming-events'
    | '/user-profil'
    | '/login'
    | '/'
    | '/articles/$articleId'
    | '/course/$courseKey'
    | '/courses/kurs-doradca-podatkowy'
    | '/courses/kurs-rachunkowosc'
    | '/courses/pop'
    | '/study/$studyId'
    | '/workshops/$type'
    | '/articles'
    | '/workshops/$type/$workshopId'
    | '/workshops/$type/$slugId/auth'
  id:
    | '__root__'
    | '/(app)/_app'
    | '/(auth)/_auth'
    | '/(app)/_app/articles'
    | '/(app)/_app/articles-brief'
    | '/(app)/_app/contact'
    | '/(app)/_app/courses'
    | '/(app)/_app/my-academy'
    | '/(app)/_app/notifications'
    | '/(app)/_app/offline-mode'
    | '/(app)/_app/offline-videos'
    | '/(app)/_app/roadShow'
    | '/(app)/_app/upcoming-events'
    | '/(app)/_app/user-profil'
    | '/(auth)/_auth/login'
    | '/(app)/_app/'
    | '/(app)/_app/articles_/$articleId'
    | '/(app)/_app/course/$courseKey'
    | '/(app)/_app/courses_/kurs-doradca-podatkowy'
    | '/(app)/_app/courses_/kurs-rachunkowosc'
    | '/(app)/_app/courses_/pop'
    | '/(app)/_app/study/$studyId'
    | '/(app)/_app/workshops/$type'
    | '/(app)/_app/articles/'
    | '/(app)/_app/workshops_/$type/$workshopId'
    | '/(app)/_app/workshops_/$type/$slugId/auth'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  appAppRoute: typeof appAppRouteWithChildren
  authAuthRoute: typeof authAuthRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(auth)/_auth': {
      id: '/(auth)/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof authAuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/_app': {
      id: '/(app)/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof appAppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/_app/': {
      id: '/(app)/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof appAppIndexRouteImport
      parentRoute: typeof appAppRoute
    }
    '/(auth)/_auth/login': {
      id: '/(auth)/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof authAuthLoginRouteImport
      parentRoute: typeof authAuthRoute
    }
    '/(app)/_app/user-profil': {
      id: '/(app)/_app/user-profil'
      path: '/user-profil'
      fullPath: '/user-profil'
      preLoaderRoute: typeof appAppUserProfilRouteImport
      parentRoute: typeof appAppRoute
    }
    '/(app)/_app/upcoming-events': {
      id: '/(app)/_app/upcoming-events'
      path: '/upcoming-events'
      fullPath: '/upcoming-events'
      preLoaderRoute: typeof appAppUpcomingEventsRouteImport
      parentRoute: typeof appAppRoute
    }
    '/(app)/_app/roadShow': {
      id: '/(app)/_app/roadShow'
      path: '/roadShow'
      fullPath: '/roadShow'
      preLoaderRoute: typeof appAppRoadShowRouteImport
      parentRoute: typeof appAppRoute
    }
    '/(app)/_app/offline-videos': {
      id: '/(app)/_app/offline-videos'
      path: '/offline-videos'
      fullPath: '/offline-videos'
      preLoaderRoute: typeof appAppOfflineVideosRouteImport
      parentRoute: typeof appAppRoute
    }
    '/(app)/_app/offline-mode': {
      id: '/(app)/_app/offline-mode'
      path: '/offline-mode'
      fullPath: '/offline-mode'
      preLoaderRoute: typeof appAppOfflineModeRouteImport
      parentRoute: typeof appAppRoute
    }
    '/(app)/_app/notifications': {
      id: '/(app)/_app/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof appAppNotificationsRouteImport
      parentRoute: typeof appAppRoute
    }
    '/(app)/_app/my-academy': {
      id: '/(app)/_app/my-academy'
      path: '/my-academy'
      fullPath: '/my-academy'
      preLoaderRoute: typeof appAppMyAcademyRouteImport
      parentRoute: typeof appAppRoute
    }
    '/(app)/_app/courses': {
      id: '/(app)/_app/courses'
      path: '/courses'
      fullPath: '/courses'
      preLoaderRoute: typeof appAppCoursesRouteImport
      parentRoute: typeof appAppRoute
    }
    '/(app)/_app/contact': {
      id: '/(app)/_app/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof appAppContactRouteImport
      parentRoute: typeof appAppRoute
    }
    '/(app)/_app/articles-brief': {
      id: '/(app)/_app/articles-brief'
      path: '/articles-brief'
      fullPath: '/articles-brief'
      preLoaderRoute: typeof appAppArticlesBriefRouteImport
      parentRoute: typeof appAppRoute
    }
    '/(app)/_app/articles': {
      id: '/(app)/_app/articles'
      path: '/articles'
      fullPath: '/articles'
      preLoaderRoute: typeof appAppArticlesRouteImport
      parentRoute: typeof appAppRoute
    }
    '/(app)/_app/articles/': {
      id: '/(app)/_app/articles/'
      path: '/'
      fullPath: '/articles/'
      preLoaderRoute: typeof appAppArticlesIndexRouteImport
      parentRoute: typeof appAppArticlesRoute
    }
    '/(app)/_app/workshops/$type': {
      id: '/(app)/_app/workshops/$type'
      path: '/workshops/$type'
      fullPath: '/workshops/$type'
      preLoaderRoute: typeof appAppWorkshopsTypeRouteImport
      parentRoute: typeof appAppRoute
    }
    '/(app)/_app/study/$studyId': {
      id: '/(app)/_app/study/$studyId'
      path: '/study/$studyId'
      fullPath: '/study/$studyId'
      preLoaderRoute: typeof appAppStudyStudyIdRouteImport
      parentRoute: typeof appAppRoute
    }
    '/(app)/_app/courses_/pop': {
      id: '/(app)/_app/courses_/pop'
      path: '/courses/pop'
      fullPath: '/courses/pop'
      preLoaderRoute: typeof appAppCoursesPopRouteImport
      parentRoute: typeof appAppRoute
    }
    '/(app)/_app/courses_/kurs-rachunkowosc': {
      id: '/(app)/_app/courses_/kurs-rachunkowosc'
      path: '/courses/kurs-rachunkowosc'
      fullPath: '/courses/kurs-rachunkowosc'
      preLoaderRoute: typeof appAppCoursesKursRachunkowoscRouteImport
      parentRoute: typeof appAppRoute
    }
    '/(app)/_app/courses_/kurs-doradca-podatkowy': {
      id: '/(app)/_app/courses_/kurs-doradca-podatkowy'
      path: '/courses/kurs-doradca-podatkowy'
      fullPath: '/courses/kurs-doradca-podatkowy'
      preLoaderRoute: typeof appAppCoursesKursDoradcaPodatkowyRouteImport
      parentRoute: typeof appAppRoute
    }
    '/(app)/_app/course/$courseKey': {
      id: '/(app)/_app/course/$courseKey'
      path: '/course/$courseKey'
      fullPath: '/course/$courseKey'
      preLoaderRoute: typeof appAppCourseCourseKeyRouteImport
      parentRoute: typeof appAppRoute
    }
    '/(app)/_app/articles_/$articleId': {
      id: '/(app)/_app/articles_/$articleId'
      path: '/articles/$articleId'
      fullPath: '/articles/$articleId'
      preLoaderRoute: typeof appAppArticlesArticleIdRouteImport
      parentRoute: typeof appAppRoute
    }
    '/(app)/_app/workshops_/$type/$workshopId': {
      id: '/(app)/_app/workshops_/$type/$workshopId'
      path: '/workshops/$type/$workshopId'
      fullPath: '/workshops/$type/$workshopId'
      preLoaderRoute: typeof appAppWorkshopsTypeWorkshopIdRouteImport
      parentRoute: typeof appAppRoute
    }
    '/(app)/_app/workshops_/$type/$slugId/auth': {
      id: '/(app)/_app/workshops_/$type/$slugId/auth'
      path: '/workshops/$type/$slugId/auth'
      fullPath: '/workshops/$type/$slugId/auth'
      preLoaderRoute: typeof appAppWorkshopsTypeSlugIdAuthRouteImport
      parentRoute: typeof appAppRoute
    }
  }
}

interface appAppArticlesRouteChildren {
  appAppArticlesIndexRoute: typeof appAppArticlesIndexRoute
}

const appAppArticlesRouteChildren: appAppArticlesRouteChildren = {
  appAppArticlesIndexRoute: appAppArticlesIndexRoute,
}

const appAppArticlesRouteWithChildren = appAppArticlesRoute._addFileChildren(
  appAppArticlesRouteChildren,
)

interface appAppRouteChildren {
  appAppArticlesRoute: typeof appAppArticlesRouteWithChildren
  appAppArticlesBriefRoute: typeof appAppArticlesBriefRoute
  appAppContactRoute: typeof appAppContactRoute
  appAppCoursesRoute: typeof appAppCoursesRoute
  appAppMyAcademyRoute: typeof appAppMyAcademyRoute
  appAppNotificationsRoute: typeof appAppNotificationsRoute
  appAppOfflineModeRoute: typeof appAppOfflineModeRoute
  appAppOfflineVideosRoute: typeof appAppOfflineVideosRoute
  appAppRoadShowRoute: typeof appAppRoadShowRoute
  appAppUpcomingEventsRoute: typeof appAppUpcomingEventsRoute
  appAppUserProfilRoute: typeof appAppUserProfilRoute
  appAppIndexRoute: typeof appAppIndexRoute
  appAppArticlesArticleIdRoute: typeof appAppArticlesArticleIdRoute
  appAppCourseCourseKeyRoute: typeof appAppCourseCourseKeyRoute
  appAppCoursesKursDoradcaPodatkowyRoute: typeof appAppCoursesKursDoradcaPodatkowyRoute
  appAppCoursesKursRachunkowoscRoute: typeof appAppCoursesKursRachunkowoscRoute
  appAppCoursesPopRoute: typeof appAppCoursesPopRoute
  appAppStudyStudyIdRoute: typeof appAppStudyStudyIdRoute
  appAppWorkshopsTypeRoute: typeof appAppWorkshopsTypeRoute
  appAppWorkshopsTypeWorkshopIdRoute: typeof appAppWorkshopsTypeWorkshopIdRoute
  appAppWorkshopsTypeSlugIdAuthRoute: typeof appAppWorkshopsTypeSlugIdAuthRoute
}

const appAppRouteChildren: appAppRouteChildren = {
  appAppArticlesRoute: appAppArticlesRouteWithChildren,
  appAppArticlesBriefRoute: appAppArticlesBriefRoute,
  appAppContactRoute: appAppContactRoute,
  appAppCoursesRoute: appAppCoursesRoute,
  appAppMyAcademyRoute: appAppMyAcademyRoute,
  appAppNotificationsRoute: appAppNotificationsRoute,
  appAppOfflineModeRoute: appAppOfflineModeRoute,
  appAppOfflineVideosRoute: appAppOfflineVideosRoute,
  appAppRoadShowRoute: appAppRoadShowRoute,
  appAppUpcomingEventsRoute: appAppUpcomingEventsRoute,
  appAppUserProfilRoute: appAppUserProfilRoute,
  appAppIndexRoute: appAppIndexRoute,
  appAppArticlesArticleIdRoute: appAppArticlesArticleIdRoute,
  appAppCourseCourseKeyRoute: appAppCourseCourseKeyRoute,
  appAppCoursesKursDoradcaPodatkowyRoute:
    appAppCoursesKursDoradcaPodatkowyRoute,
  appAppCoursesKursRachunkowoscRoute: appAppCoursesKursRachunkowoscRoute,
  appAppCoursesPopRoute: appAppCoursesPopRoute,
  appAppStudyStudyIdRoute: appAppStudyStudyIdRoute,
  appAppWorkshopsTypeRoute: appAppWorkshopsTypeRoute,
  appAppWorkshopsTypeWorkshopIdRoute: appAppWorkshopsTypeWorkshopIdRoute,
  appAppWorkshopsTypeSlugIdAuthRoute: appAppWorkshopsTypeSlugIdAuthRoute,
}

const appAppRouteWithChildren =
  appAppRoute._addFileChildren(appAppRouteChildren)

interface authAuthRouteChildren {
  authAuthLoginRoute: typeof authAuthLoginRoute
}

const authAuthRouteChildren: authAuthRouteChildren = {
  authAuthLoginRoute: authAuthLoginRoute,
}

const authAuthRouteWithChildren = authAuthRoute._addFileChildren(
  authAuthRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  appAppRoute: appAppRouteWithChildren,
  authAuthRoute: authAuthRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
